// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3ahuu","tab":"ProcedureTabs_tab__aERX1"};